<form [formGroup]="form" class="formgrid grid">
  <div class="field col-12">
    <label>Kontoinhaber</label>
    <div class="flex flex-wrap gap-3 mb-3">
      <div class="flex align-items-center">
        <p-radioButton
          [value]="true"
          formControlName="inherit"
          inputId="inheritBankingContactInputTrue"
        ></p-radioButton>
        <label for="inheritBankingContactInputTrue" class="ml-2">Wie Auftraggeber</label>
      </div>
      <div class="flex align-items-center">
        <p-radioButton
          [value]="false"
          formControlName="inherit"
          inputId="inheritBankingContactInputFalse"
        ></p-radioButton>
        <label for="inheritBankingContactInputFalse" class="ml-2">Neue Angabe</label>
      </div>
    </div>
  </div>
  <ng-container *ngIf="showContactFields()">
    <div class="field col-12">
      <label for="firstNameInput"
        >Vorname<ow-validation-mark [control]="form.controls.firstName"></ow-validation-mark
      ></label>
      <input type="text" pInputText id="firstNameInput" formControlName="firstName" class="w-full" />
    </div>
    <div class="field col-12">
      <label for="lastNameInput"
        >Nachname<ow-validation-mark [control]="form.controls.lastName"></ow-validation-mark
      ></label>
      <input type="text" pInputText id="lastNameInput" formControlName="lastName" class="w-full" />
    </div>
  </ng-container>
  <div class="field col-12">
    <label for="ibanInput">IBAN<ow-validation-mark [control]="form.controls.iban"></ow-validation-mark></label>
    <input type="text" pInputText id="ibanInput" formControlName="iban" class="w-full" />
  </div>
  <div class="field col-12">
    <label for="bicInput"
      >BIC<ow-validation-mark [control]="form.controls.bic"></ow-validation-mark
    ></label>
    <input type="text" pInputText id="bicInput" formControlName="bic" class="w-full" />
  </div>
  <div class="field col-12">
    <label for="creditInstitutionInput"
      >Kreditinstitut<ow-validation-mark [control]="form.controls.creditInstitution"></ow-validation-mark
    ></label>
    <input type="text" pInputText id="creditInstitutionInput" formControlName="creditInstitution" class="w-full" />
  </div>
  <div class="field col-12">
    <label>SEPA Lastschriftmandat<ow-validation-mark [control]="form.controls.authorize"></ow-validation-mark></label>
    <div class="flex align-items-center gap-2">
      <p-checkbox formControlName="authorize" [binary]="true" inputId="authorizeInput"></p-checkbox>
      <label for="authorizeInput"
        >Ich ermächtige Stadtwerke Saarlouis GmbH, Zahlungen von dem angegebenen Konto mittels Lastschrift einzuziehen. Zugleich
        weise ich das angegebene Kreditinstitut an, die von Stadtwerke Saarlouis GmbH auf das angegebene Konto gezogene Lastschrift
        einzulösen. Die Stadtwerke Saarlouis GmbH akzeptiert ausschließlich das Bankeinzugsverfahren. Eine Barzahlung
        oder Überweisung ist nicht möglich.</label
      >
    </div>
  </div>
</form>
